import { motion } from 'motion/react'
import { Route, Compass, FileSearch, BookOpen } from 'lucide-react'
import { useLanguage } from '@/i18n/LanguageContext'

const SERVICE_META = [
  { number: '01', icon: Route, rotate: 'md:rotate-[-1.5deg]', offset: 'md:mt-0' },
  { number: '02', icon: Compass, rotate: 'md:rotate-[1.2deg]', offset: 'md:mt-14' },
  { number: '03', icon: FileSearch, rotate: 'md:rotate-[1.8deg]', offset: 'md:mt-6' },
  { number: '04', icon: BookOpen, rotate: 'md:rotate-[-1.2deg]', offset: 'md:mt-20' },
]

export default function ServicesSection() {
  const { t } = useLanguage()

  const services = t.services.items.map((service, i) => ({ ...service, ...SERVICE_META[i] }))

  return (
    <section id="servizi" className="relative bg-cream pt-24 pb-8 md:pt-32 md:pb-12 overflow-hidden">
      <div className="mx-auto max-w-6xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <p className="text-sm uppercase tracking-[0.25em] text-terracotta font-medium mb-4">
            {t.services.eyebrow}
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-ink leading-tight">
            {t.services.titleBefore}{' '}
            <span className="italic text-terracotta">{t.services.titleAccent}</span>
          </h2>
        </motion.div>

        <div className="mt-16 grid gap-8 md:grid-cols-2 md:gap-x-10">
          {services.map((service, i) => (
            <div key={service.number} className={`relative ${service.offset}`}>
              {i === 1 && (
                <div className="pointer-events-none absolute -top-36 left-1/2 z-0 hidden w-32 -translate-x-1/2 select-none sm:w-40 md:-top-56 md:block md:w-52">
                  <motion.img
                    src="/images/capitello.png"
                    alt=""
                    aria-hidden="true"
                    initial={{ opacity: 0, y: 90 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-80px' }}
                    transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
                    className="h-auto w-full"
                  />
                </div>
              )}
              <motion.article
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                whileHover={{ y: -6, transition: { type: 'spring', stiffness: 300, damping: 20 } }}
                className={`relative z-10 rounded-[2rem] bg-white p-8 md:p-10 shadow-[0_18px_50px_-20px_rgba(15,43,70,0.25)] border border-ink/5 ${service.rotate}`}
              >
              <div className="flex items-start justify-between">
                <span className="font-display text-6xl md:text-7xl text-terracotta/25 leading-none select-none">
                  {service.number}
                </span>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
                  <service.icon className="h-6 w-6" strokeWidth={1.8} />
                </span>
              </div>
              <h3 className="mt-4 font-display text-2xl md:text-3xl text-ink">
                {service.title}
              </h3>
              <p className="mt-4 text-ink/70 leading-relaxed">
                {service.description}
              </p>
              </motion.article>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
